module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['sky-reveal-trigger', {
      open: _vm.isOpen
    }],
    on: {
      "click": _vm.toggle
    }
  }, [_vm._t("svg"), _vm._v(" "), _vm._t("svg-append"), _vm._v(" "), (!_vm.isOpen) ? _vm._t("open") : _vm._t("closed"), _vm._v(" "), _vm._t("svg-prepend")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-61d92c19"}!./scripts/sky-reveal/SkyRevealTrigger.html
// module id = 371
// module chunks = 1